export enum VisibilityEnum {
    All = 0,
    Unauthenticated = 1,
    Authenticated = 2,
}
